<gp-modal #askForSignaturePopup
          [closable]="true"
          size="lg"
          gp-modal="ask-for-signature">
  <div class="gp-modal-title signature-popup-title">
    <span>{{ 'DOCUMENTS.send_for_signature' | translate }}</span>
  </div>
  <div class="gp-modal-body signature-popup">
    <ng-container *ngIf="popupContentVisible">
      <section class="signature-popup-section">
        <div class="signature-section-heading">
          <h4 class="signature-section-title">1. {{ 'DOCUMENTS.assign_signers' | translate }}</h4>
          <label class="checkbox mb-0 signing-order-toggle"
                 [class.text-muted]="signatureRoles.length < 2">
            <input type="checkbox"
                   test-id="signatureOrderToggle"
                   [checked]="signatureOrderMode === 'ORDERED'"
                   [disabled]="signatureRoles.length < 2"
                   (change)="changeSignatureOrderMode($event.target['checked'])">
            {{ 'DOCUMENTS.sequential_signing' | translate }}
            <em class="fa-solid fa-circle-info fa-xs" container="body"
              placement="bottom" [adaptivePosition]="false"
              [tooltip]="'DOCUMENTS.sequential_signing_help' | translate"></em>
          </label>
        </div>
        <div class="signature-role-list">
          <div *ngFor="let role of signatureRoles; let i = index"
               (dragover)="allowSignerRoleDrop($event)"
               (drop)="dropSignerRole(i, $event)"
               class="signature-role-item"
               [class.signature-role-item--dragging]="draggedSignerRoleIndex === i"
               test-id="signatureRoleItem">
            <div class="signature-role-content">
              <button *ngIf="signatureOrderMode === 'ORDERED'"
                      (dragend)="stopDraggingSignerRole()"
                      (dragstart)="startDraggingSignerRole(i, $event)"
                      [attr.aria-label]="'TEMPLATE.reorder_signer_role' | translate"
                      class="btn btn-sm btn-icon signature-role-drag-handle"
                      draggable="true"
                      test-id="dragSignerRole"
                      type="button">
                <em aria-hidden="true" class="fa fa-solid fa-grip-vertical"></em>
              </button>
              <div class="row signature-role-fields">
                <div class="col-md-4 signature-field">
                  <label class="signature-role-name text-ellipsis" [title]="role">
                    <ng-container *ngIf="signatureOrderMode === 'ORDERED'">{{ i + 1 }}. </ng-container>{{ role | translate }}
                  </label>
                  <gp-employee-select (selectedChange)="updateSignatureSelection(i, 'employee', $event)">
                  </gp-employee-select>
                </div>
                <div class="signature-field" [class.col-md-4]="isSmsOtpSelected" [class.col-md-8]="!isSmsOtpSelected">
                  <label [for]="'signature-email-' + i">
                    {{ 'DOCUMENTS.signature_email_address' | translate }} <span class="text-danger">*</span>
                  </label>
                  <input type="email"
                         class="form-control"
                         [class.is-invalid]="signatureSelections[i]?.contactLoaded && !isEmailValid(signatureSelections[i]?.email)"
                         [id]="'signature-email-' + i"
                         [disabled]="!signatureSelections[i]?.employee || !signatureSelections[i]?.contactLoaded"
                         [value]="signatureSelections[i]?.email"
                         (input)="updateSignatureContact(i, 'email', $event.target['value'])">
                </div>
                <div *ngIf="isSmsOtpSelected" class="col-md-4 signature-field">
                  <label [id]="'signature-phone-label-' + i">
                    {{ 'DOCUMENTS.signature_phone_number' | translate }} <span class="text-danger">*</span>
                  </label>
                  <div class="flex flex-row input-group signature-phone-controls">
                    <span *ngIf="signatureSelections[i]?.employee && signatureSelections[i]?.contactLoaded"
                      class="input-group-addon signature-phone-prefix">
                      <ng-select class="signature-phone-prefix-select"
                                 [attr.aria-labelledby]="'signature-phone-label-' + i"
                                 [allowClear]="false"
                                 [idField]="'value'"
                                 [textField]="'display'"
                                 [calcDropdownPosition]="positionPhoneCountryCodeDropdown"
                                 [items]="signatureSelections[i]?.phoneCountryCodeOptions"
                                 [active]="getActivePhoneCountryCode(signatureSelections[i])"
                                 [sortByTranslationsEnabled]="false"
                                 (selected)="updatePhoneCountryCode(i, $event)">
                      </ng-select>
                    </span>
                    <input type="tel"
                           class="form-control"
                           [class.is-invalid]="signatureSelections[i]?.contactLoaded
                             && !isPhoneNumberValid(signatureSelections[i])"
                           [attr.aria-labelledby]="'signature-phone-label-' + i"
                           [id]="'signature-phone-' + i"
                           [disabled]="!signatureSelections[i]?.employee || !signatureSelections[i]?.contactLoaded"
                           [value]="signatureSelections[i]?.phoneNumber"
                           (input)="updatePhoneNumber(i, $event.target['value'])">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="signature-popup-section signature-method-section">
        <h4 class="signature-section-title">
          2. {{ 'DOCUMENTS.signature_method' | translate }}
        </h4>
        <gp-signature-method-select [options]="signatureMethodOptions"
                                    [selected]="selectedSignatureMethods"
                                    [compact]="true"
                                    [multiple]="true"
                                    (selectedChange)="selectSignatureMethod($event)">
        </gp-signature-method-select>
      </section>
    </ng-container>
  </div>
  <div class="gp-modal-footer signature-popup-footer">
    <span class="signature-assignment-progress">
      {{ 'DOCUMENTS.signature_assignment_progress' | translate: {
        assigned: assignedSignerCount,
        total: signatureRoles.length
      } }}
    </span>
    <div class="btn-bar-wrapper signature-popup-actions">
      <div class="btn-bar btn-bar-sm btn-bar-align-end">
        <button (click)="confirmSignature(askForSignaturePopup)"
                [disabled]="!isSignatureFormValid || signatureSubmitting"
              class="btn btn-fill-primary p-x-md"
                type="button">
          <i *ngIf="signatureSubmitting" class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
            <i *ngIf="!signatureSubmitting" class="fa fa-light fa-paper-plane" aria-hidden="true"></i>
          {{ 'DOCUMENTS.send_for_signature' | translate }}
        </button>
      </div>
    </div>
  </div>
</gp-modal>
